// angular
import { Injectable } from '@angular/core';

// addons
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, mergeMap, withLatestFrom, filter } from 'rxjs/operators';

// service
import { TradeService } from '@core/services';

// store
import { select, Store } from '@ngrx/store';
import * as actions from './actions';
import * as fromTrade from '../trade';
import * as fromUI from '../ui';

// model
import {
  ITradeComment,
  ITradeCommentSubmit,
  ITrade,
  TradeCommentType,
} from '@shared/models';

@Injectable()
export class FeedEffects {
  loadFeed$ = createEffect(() => this.actions$.pipe(
    ofType(actions.ActionTypes.Load),
    withLatestFrom(
      this.store.pipe(select(fromTrade.TradeSelectors.getTrade)),
      this.store.pipe(select(fromUI.UiSelectors.getFeedFilter)),
    ),
    mergeMap(([_, trade, feedType]: [any, ITrade, TradeCommentType]) => {
      return this.tradeService.getTradeFeed(trade.id, feedType).pipe(
        map((tradeFeed: ITradeComment[]) => actions.loadSuccess({ tradeFeed }))
      );
    })
  ));

  addComment$ = createEffect(() => this.actions$.pipe(
    ofType(actions.ActionTypes.AddComment),
    withLatestFrom(this.store.pipe(select(fromTrade.TradeSelectors.getTrade))),
    mergeMap(([{ comment }, { id } ]: [{ comment: ITradeCommentSubmit }, ITrade]) => {
      return this.tradeService.addComment(id, comment).pipe(
        map(() => actions.load())
      );
    })
  ));

  constructor(
    private actions$: Actions,
    private tradeService: TradeService,
    private store: Store<fromTrade.TradeState.State>
  ) {}
}
